/* eslint-disable */
import React from 'react'
import axios from "axios";
import { useParams, useNavigate } from 'react-router'
import { useDispatch, useSelector } from "react-redux"
import { getSuccess, getFailure } from '../Redux/getData/action'
import Error from '../Utils/10.svg'
import Image1 from '../Utils/10.svg'
import { 
  Container, 
  Box, 
  Typography, 
  Chip, 
  IconButton,
  Button,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  ArrowBack,
  Share,
  BookmarkBorder,
  Visibility,
  Comment,
  CalendarToday,
  Person,
  OpenInNew
} from '@material-ui/icons'
import Comments from './Comment';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(0),
    background: '#ffffff',
    minHeight: '100vh',
  },
  backButton: {
    textTransform: 'none',
    borderRadius: 4,
    padding: theme.spacing(1, 3),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderColor: '#121212',
    color: '#121212',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    }
  },
  articleContainer: {
    maxWidth: 800,
    margin: '0 auto',
    background: 'white',
    borderRadius: 0,
    overflow: 'hidden',
  },
  heroImage: {
    width: '100%',
    height: 400,
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      height: 250,
    },
  },
  contentSection: {
    padding: theme.spacing(4, 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 0),
    },
  },
  title: {
    fontSize: '2.25rem',
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: theme.spacing(3),
    color: '#121212',
    fontFamily: '"Georgia", serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.75rem',
    },
  },
  abstract: {
    fontSize: '1.25rem',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#666',
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 0, 3, 0),
    borderBottom: '1px solid #e0e0e0',
    fontFamily: '"Georgia", serif',
  },
  metaSection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap',
    padding: theme.spacing(2, 0),
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: '#666',
    fontSize: '0.9rem',
  },
  metaIcon: {
    color: '#666',
    fontSize: '1.1rem',
  },
  statsSection: {
    display: 'flex',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2, 0),
    borderBottom: '1px solid #e0e0e0',
  },
  statItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  statNumber: {
    fontWeight: 600,
    color: '#121212',
  },
  statLabel: {
    color: '#666',
    fontSize: '0.9rem',
  },
  content: {
    fontSize: '1.125rem',
    lineHeight: 1.7,
    color: '#333',
    marginBottom: theme.spacing(4),
    fontFamily: '"Georgia", serif',
    '& p': {
      marginBottom: theme.spacing(2),
    },
  },
  tagsSection: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2, 0),
    borderTop: '1px solid #e0e0e0',
  },
  tagChip: {
    borderRadius: 4,
    fontWeight: 500,
    backgroundColor: '#f5f5f5',
    color: '#666',
    border: '1px solid #e0e0e0',
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(3, 0),
    borderTop: '1px solid #e0e0e0',
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  externalButton: {
    borderRadius: 4,
    padding: theme.spacing(1, 3),
    textTransform: 'none',
    fontWeight: 500,
    backgroundColor: '#121212',
    color: 'white',
    '&:hover': {
      backgroundColor: '#333333',
    }
  },
  errorContainer: {
    textAlign: 'center',
    padding: theme.spacing(8, 2),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
}));

const SectionNews = () => {
  const classes = useStyles();
  const { name } = useParams();
  const navigate = useNavigate();
  const { news, isLoading, isError } = useSelector((state) => state.getData);
  const dispatch = useDispatch();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [news, name]);

  const getNewsData = () => {
    const url = `https://jtimes.zuddo.biz/main/article/${name.toLowerCase()}`
    axios.get(url)
      .then(res => {
        dispatch(getSuccess(res.data));
      })
      .catch(err => {
        dispatch(getFailure());
      })
  }

  React.useEffect(() => {
    getNewsData();
  }, [name]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: news?.title,
          text: news?.abstract,
          url: window.location.href,
        });
      } catch (err) {
        console.log('Share cancelled');
      }
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert('Article link copied to clipboard!');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown date';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  }; 

  const getImageUrl = () => {
    const API_BASE_URL = 'https://jtimes.zuddo.biz/main/api/getimage'+news?.image_url;
    if (API_BASE_URL && API_BASE_URL?.length > 0) {

      return API_BASE_URL;
    }
    return 'https://via.placeholder.com/800x400/ffffff/cccccc?text=New+York+Times';
  };
  
  if (isLoading) {
    return (
      <Box className={classes.root}>
        <Container maxWidth="md">
          <Box className={classes.loadingContainer}>
            <div style={{ 
              width: 60, 
              height: 60, 
              border: '3px solid #f3f3f3', 
              borderTop: '3px solid #121212', 
              borderRadius: '50%', 
              animation: 'spin 1s linear infinite' 
            }} />
            <Typography variant="h6" color="textSecondary">
              Loading Article...
            </Typography>
          </Box>
        </Container>
      </Box>
    );
  }

  if (isError || !news) {
    return (
      <Box className={classes.root}>
        <Container maxWidth="md">
          <Box className={classes.errorContainer}>
            <img src={Error} alt="404 error" width="200px" height="200px" />
            <Typography variant="h5" gutterBottom style={{ marginTop: 20, color: '#121212' }}>
              Article Not Found
            </Typography>
            <Typography variant="body1" color="textSecondary" paragraph>
              We couldn't load the article you're looking for.
            </Typography>
            <Button
              variant="outlined"
              onClick={handleBack}
              className={classes.backButton}
              startIcon={<ArrowBack />}
            >
              Back to Articles
            </Button>
          </Box>
        </Container>
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      <Container maxWidth="md">
        <Button
          startIcon={<ArrowBack />}
          onClick={handleBack}
          className={classes.backButton}
          variant="outlined"
        >
          Back to Articles
        </Button>

        <Box className={classes.articleContainer}>

          <img
            src={getImageUrl()}
            alt={news.title}
            className={classes.heroImage}
          />

          <Box className={classes.contentSection}>
            <Typography variant="h1" className={classes.title}>
              {news.title}
            </Typography>

                    <Box className={classes.content}>
              {news.content ? (
                <div dangerouslySetInnerHTML={{ __html: news.content }} />
              ) : (
                <Typography variant="body1">
                  {news.abstract || 'No additional content available for this article.'}
                </Typography>
              )}
            </Box>

            <Box className={classes.metaSection}>
              {news.byline && (
                <Box className={classes.metaItem}>
                  <Person className={classes.metaIcon} />
                  <Typography variant="body2">{news.byline}</Typography>
                </Box>
              )}
              
              {news.published_date && (
                <Box className={classes.metaItem}>
                  <CalendarToday className={classes.metaIcon} />
                  <Typography variant="body2">
                    {formatDate(news.published_date)}
                  </Typography>
                </Box>
              )}
            </Box>

            <Box className={classes.statsSection}>
              <Box className={classes.statItem}>
                <Visibility className={classes.metaIcon} />
                <Typography className={classes.statNumber}>
                  {news.view_count || '0'}
                </Typography>
                <Typography className={classes.statLabel}>Views</Typography>
              </Box>
              
              <Box className={classes.statItem}>
                <Comment className={classes.metaIcon} />
                <Typography className={classes.statNumber}>
                  {news.comment_count || '0'}
                </Typography>
                <Typography className={classes.statLabel}>Comments</Typography>
              </Box>
            </Box>

                {news.abstract && (
              <Typography variant="h6" className={classes.abstract}>
                {news.abstract}
              </Typography>
            )}

            {(news.section || news.subsection || news.news_desk) && (
              <Box className={classes.tagsSection}>
                {news.section && (
                  <Chip label={`Section: ${news.section}`} className={classes.tagChip} />
                )}
                {news.subsection && (
                  <Chip label={`Subsection: ${news.subsection}`} className={classes.tagChip} />
                )}
                {news.news_desk && (
                  <Chip label={`Desk: ${news.news_desk}`} className={classes.tagChip} />
                )}
              </Box>
            )}
            <Comments/>
            <Box className={classes.actionBar}>
              <Box className={classes.actionButtons}>
                <IconButton onClick={handleShare} aria-label="share article">
                  <Share style={{ color: '#666' }} />
                </IconButton>
                <IconButton aria-label="bookmark article">
                  <BookmarkBorder style={{ color: '#666' }} />
                </IconButton>
              </Box>
              
              {news.url && (
                <a
                  href={Image1}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none' }}
                >
                  <Button
                    variant="contained"
                    className={classes.externalButton}
                    endIcon={<OpenInNew />}
                  >
                    Read on JubaTimes.com
                  </Button>
                </a>
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default SectionNews;